import styled from "styled-components";
import { Theme } from "../../types/Theme";

interface IContainerProps {
    theme: Theme;
}

export const Container = styled.div<IContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    background-color: ${props => props.theme.backgroundPage};

`;

export const Card = styled.div<IContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${props => props.theme.backgroundCard};
    border-radius: 16px;
    width: 40%;
    height: 20%;
    justify-content: space-around;
    min-width: 400px;
    padding-top: 20px;

    img {
        width: 60%;
    }



`;